import { bootstrapControllerGetSession } from "./generated"

export const getBootstrapSession = (accessToken: string) =>
  bootstrapControllerGetSession({
    headers: { Authorization: `Bearer ${accessToken}` },
  })
